import { useEffect, useContext, useMemo } from "preact/compat";
import { GlobalContext } from "@/context/GlobalContext";
import useLocalStorageState from "use-local-storage-state";
import { trackPurchase } from "@/gtm-analytics";
import LocationIcon from "@/icons/location.svg";
import PhoneIcon from "@/icons/phone.svg";
import ClockIcon from "@/icons/clock.svg";
import { surfsideTrackPurchase } from "@/shared/surfside-analytics";

function OrderConfirmation() {
	const [retailer, setRetailer] = useLocalStorageState("dutchie_retailer", null);
	const retailerId = retailer?.id;
	const retailerSlug = retailer?.slug;
	const [checkoutId, setCheckoutId, { removeItem }] = useLocalStorageState("dutchie_checkout_" + retailerSlug);
	const [hasCompletedCheckout, setHasCompletedCheckout] = useLocalStorageState("cp_has_completed_checkout");
	const [cartItems, setCartItems] = useLocalStorageState("dutchie_cart_items");
	const { checkout, setCheckout } = useContext(GlobalContext);

	let location = useMemo(() => {
		return dutchie.retailers.find(retailer => (retailer.id === retailerId));
	}, []);

	const params = new URLSearchParams(document.location.search);
	const transactionID = params.get("orderNumber");

	useEffect(() => {
		trackCheckout();
		setHasCompletedCheckout(true);
		removeItem(); // Remove Checkout ID from localStorage.
		clearPromoSessionStorage();
		setCartItems([]);
	}, []);

	function trackCheckout() {

		if (cartItems && Object.hasOwn(cartItems, 'items')) {
			console.log('checking for cartItems');
			console.log(cartItems);

			const purchase = {
				transaction_id: transactionID,
				value: cartItems.value,
				tax: cartItems.tax,
				shipping: 0,
				currency: "USD",
				coupon: cartItems.coupon,
				items: cartItems.items,
			};

			trackPurchase(purchase);

			console.log('tracking purchase');
			console.log(purchase);

			console.log('checking typeof surf');
			console.log(typeof surf);

			if (typeof surf !== 'undefined') {
				console.log('tracking surfside purchase');
				surfsideTrackPurchase(purchase);
			}
		}
	}

	function clearPromoSessionStorage() {
		// Get all the keys in sessionStorage that start with 'cp_promo_item_'
		const keys = Object.keys(sessionStorage).filter(key => key.startsWith('cp_promo_item_'));

		// Remove each item from sessionStorage
		for (const key of keys) {
			sessionStorage.removeItem(key);
		}
	}

	return (
		<div className="order-confirmation">
			<div className="container">
				<div className="confirmation-store-info">
					<div className="flex-col flex-col-4">
						<div className="flex-col-item">
							<h4 className="">
								{retailer?.name}
							</h4>
							<h3 className="order-confirmation-store-header">Store Info</h3>
						</div>
						<div className="flex-col-item">
							<LocationIcon />
							<h4>Store Address</h4>
							<p>{retailer.line1 && `${retailer.line1}`}
								{retailer.line1 && (
									<br />
								)}
								{retailer?.city && `${retailer.city},`}
								{retailer?.state && `${retailer?.state}`} {retailer?.zipCode}</p>
						</div>

						{location.hours_static ? (
							<div className="flex-col-item store-hours">
								<ClockIcon />
								<h4>Hours</h4>
								<p dangerouslySetInnerHTML={{ __html: location.hours_static }}></p>
							</div>
						) : null}

						<div className="flex-col-item">
							<PhoneIcon />
							<h4>Contact</h4>
							<a href={`tel: ${location?.phone}`}>{location?.phone}</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
export default OrderConfirmation;
